var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmsAuthentication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    fill: "#6EE7B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6 12C13.166 12 12 13.166 12 14.6C12 21.988 18.011 28 25.4 28C26.833 28 28 26.834 28 25.4C28 25.289 27.993 25.18 27.979 25.072L23.359 24.012C23.267 24.188 23.166 24.379 23.074 24.557C22.618 25.427 22.288 26.059 21.446 25.72C18.14 24.56 15.441 21.86 14.266 18.514C13.909 17.729 14.589 17.373 15.451 16.923C15.626 16.831 15.815 16.732 15.988 16.642L14.928 12.021C14.817 12.007 14.709 12 14.6 12ZM25.4 30C16.908 30 10 23.092 10 14.6C10 12.063 12.063 10 14.6 10C14.86 10 15.117 10.022 15.366 10.065C15.609 10.104 15.853 10.166 16.091 10.248C16.416 10.361 16.661 10.634 16.738 10.97L18.107 16.934C18.183 17.262 18.088 17.606 17.854 17.85C17.718 17.992 17.715 17.995 16.475 18.644C17.479 20.818 19.224 22.557 21.354 23.527C22.004 22.286 22.008 22.282 22.15 22.146C22.394 21.912 22.74 21.821 23.066 21.893L29.031 23.262C29.366 23.339 29.639 23.583 29.751 23.908C29.833 24.144 29.895 24.388 29.936 24.639C29.978 24.886 30 25.142 30 25.4C30 27.937 27.936 30 25.4 30Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsAuthentication);
export default __webpack_public_path__ + "static/media/sms-authentication.16bb804116251b95ed16156950b4a5b2.svg";
export { ForwardRef as ReactComponent };